/**
 *  검색 사전 페이지명 (AMZUWEB-694)
 */
export const SEARCH_DICTIONARY_PAGE_NAME = {
  MAIN: '검색 사전',
  RULE_CREATE: '동의어 규칙 등록',
  RULE_DETAIL: '동의어 규칙 상세',
};
